import styled, { css } from "styled-components"

interface StyledTypographyProps {
  $size: number
  $weight: number
  $lineHeight: number
  $color?: string
  $uppercase?: boolean
  $truncate?: boolean
  $lineClamp?: number
  $align?: "left" | "center" | "right"
}

export const StyledTypography = styled.span<StyledTypographyProps>`
  font-size: ${({ $size }) => $size}px;
  font-weight: ${({ $weight }) => $weight};
  line-height: ${({ $lineHeight }) => $lineHeight};
  margin: 0;

  ${({ $color }) => $color && css`color: ${$color};`}
  ${({ $align }) => $align && css`text-align: ${$align};`}

  ${({ $uppercase }) =>
    $uppercase &&
    css`
      text-transform: uppercase;
      letter-spacing: 0.05em;
    `}

  ${({ $truncate, $lineClamp }) =>
    $lineClamp
      ? css`
          display: -webkit-box;
          -webkit-line-clamp: ${$lineClamp};
          -webkit-box-orient: vertical;
          overflow: hidden;
        `
      : $truncate &&
        css`
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `}
`
